import { useApolloClient } from '@apollo/client';
import { getOperationName } from '@apollo/client/utilities';
import { useGraphQLMutation } from '@betterment/graphql';
import { compact } from 'es-toolkit/compat';

import { EnvelopeAccountActivityDocument } from '../../../../account/components/activity-card/graphql/envelopeAccountActivity.generated';
import { EnvelopeAccountPendingOrdersDocument } from '../../../../account/components/pending-orders-card/graphql/envelopeAccountPendingOrders.generated';
import { DirectTradingAccountBuySellAvailabilityDocument } from '../../../../account-security/components/actions-card/graphql/directTradingAccountBuySellAvailability.generated';
import { DirectTradingAccountSecurityPositionsDocument } from '../../../../account-security/components/security-position-details-card/graphql/directTradingAccountSecurityPositions.generated';
import { CancelTransactionRequestDocument } from '../../../graphql/mutation.cancelTransactionRequest.generated';
import { ActivityItemsDocument } from '../../../graphql/query.activityItems.generated';

export const useCancelTransaction = () => {
  const client = useApolloClient();

  const [cancelTransaction, { loading, error }] = useGraphQLMutation(CancelTransactionRequestDocument, {
    onCompleted: () =>
      // TODO: We need to find a better pattern for this
      client.refetchQueries({
        include: compact([
          getOperationName(ActivityItemsDocument),
          getOperationName(EnvelopeAccountActivityDocument),
          getOperationName(DirectTradingAccountSecurityPositionsDocument),
          getOperationName(DirectTradingAccountBuySellAvailabilityDocument),
          getOperationName(EnvelopeAccountPendingOrdersDocument),
        ]),
      }),
  });

  return { cancelTransaction, loading, error };
};
